import { createSlice } from '@reduxjs/toolkit';

import { AlertSettingsUser } from 'entities/AlertSettingsUser';
import { AppError } from 'entities/Errors';

import {
  getAlertSettingsUserList,
  updateAlertSettingsUser,
} from './alert_settings_user.action';

interface AlertState {
  action: 'idle' | 'list' | 'update' | 'refresh';
  status: 'idle' | 'loading' | 'failed' | 'successed';
  error: null | AppError;
  alertSettingsUserList: AlertSettingsUser[];
}

const initialState: AlertState = {
  action: 'idle',
  status: 'idle',
  alertSettingsUserList: [],
  error: null,
};

export const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    refresh: (state) => {
      state.error = null;
      state.action = 'idle';
      state.status = 'idle';
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getAlertSettingsUserList.pending, (state) => {
        state.action = 'list';
        state.status = 'loading';
        state.error = null;
      })
      .addCase(getAlertSettingsUserList.fulfilled, (state, action) => {
        state.status = 'successed';
        state.alertSettingsUserList = action.payload.data;
      })
      .addCase(getAlertSettingsUserList.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as AppError;
      })
      .addCase(updateAlertSettingsUser.pending, (state) => {
        state.status = 'loading';
        state.action = 'update';
        state.error = null;
      })
      .addCase(updateAlertSettingsUser.fulfilled, (state, action) => {
        state.status = 'successed';
        const newAlertSettingsUserList = state.alertSettingsUserList.filter(
          (x) => x.alertSettings.id !== action.payload.data.alertSettings.id
        );

        state.alertSettingsUserList = [
          ...newAlertSettingsUserList,
          action.payload.data,
        ];
        // state.alertSettingsUserList = state.alertSettingsUserList.filter(
        //   (x) => x.alertSettings.id !== action.payload.data.id,
        // );
      })
      .addCase(updateAlertSettingsUser.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as AppError;
      });
  },
});

export const { refresh: alertRefresh } = alertSlice.actions;

export default alertSlice.reducer;
